import React from "react";
import { Link } from "react-router-dom";

/**
 * Level-selection tile.
 *
 * Renders as a React-Router `<Link>` when `disabled` is `false`; falls back to a
 * disabled `<button>` otherwise.  Keeps the exact same visual layout for both
 * states so the grid doesn’t jump.
 *
 * @param {object}  props
 * @param {string}  props.to                 Destination path for the router (ignored when disabled).
 * @param {string}  props.title              Bold headline shown inside the tile.
 * @param {string}  props.desc               Short description under the headline.
 * @param {boolean} [props.disabled=false]   When true, tile is inert and greyed-out.
 *
 * @returns {JSX.Element}
 */
export default function LevelTile({ to, title, desc, disabled = false }) {
  const inner = (
    <>
      <span className="btn-title">{title}</span>
      <span className="btn-desc">{desc}</span>
    </>
  );

  return disabled ? (
    <button className="primary-button opacity-50" disabled>
      {inner}
    </button>
  ) : (
    <Link to={to} replace className="primary-button">
      {inner}
    </Link>
  );
}
